var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigNotificaciones = function SvgConfigNotificaciones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "config_notificaciones_svg__Capa_2",
    viewBox: "0 0 39.44 38.58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "config_notificaciones_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.97 26.8c-5.16 0-3.84-10.72-4.78-16.53C27.26 4.46 22.92 0 17.34 0S7.42 4.46 6.49 10.27 6.87 26.8 1.71 26.8c-.95 0-1.71.81-1.71 1.8v.65c0 .79.61 1.43 1.36 1.43h31.96c.75 0 1.36-.64 1.36-1.43v-.65c0-1-.77-1.8-1.71-1.8",
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.34 38.58c3.02 0 5.54-2.1 6.21-4.91H11.13c.67 2.81 3.19 4.91 6.21 4.91",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.9,
    cy: 9.51,
    r: 7.54,
    fill: "#ff1b51"
  }))));
};
export default SvgConfigNotificaciones;